import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "login-background login-container"
  }, [_c('div', {
    staticClass: "login-main"
  }, [_c('img', {
    staticClass: "login-logo",
    attrs: {
      "src": require("@/assets/images/logo.png")
    }
  }), _c('div', {
    staticClass: "msg-box"
  }, [_c('my-form-modal', {
    attrs: {
      "data-sign": "customer_platform_tiktok_account_auth_modal",
      "width": 600,
      "title": _vm.t('新增TIKTOK账号')
    }
  }, [_c('a-form-model', {
    ref: "formDataRef",
    attrs: {
      "rules": _vm.formDataRule,
      "model": _vm.formData,
      "data-sign": "customer_platform_tiktok_account_auth_form"
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u6388\u6743\u5E97\u94FA\u7C7B\u578B"),
      "prop": "site",
      "label": _vm.t('授权店铺类型')
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('请选择授权店铺类型'),
      "disabled": _vm.isFromGd
    },
    model: {
      value: _vm.formData.site,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "site", $$v);
      },
      expression: "formData.site"
    }
  }, _vm._l(_vm.tiktokSiteEnum, function (item) {
    return _c('a-select-option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1)], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5E73\u53F0\u8D26\u53F7"),
      "prop": "user_account",
      "label": _vm.t('平台账号')
    }
  }, [_c('my-input', {
    staticClass: "form-item-input",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "show-search": "",
      "disabled": _vm.isFromGd,
      "placeholder": _vm.t('请填写平台Shop Code'),
      "maxLength": 50
    },
    model: {
      value: _vm.formData.user_account,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "user_account", $$v);
      },
      expression: "formData.user_account"
    }
  }), _c('common-tips', {
    attrs: {
      "data": [_vm.t('请填写平台Shop Code。')]
    }
  }), _vm.formData.site === _vm.$enum.mine.TiktokSiteEnum.US_LOCAL ? _c('div', {
    staticClass: "note-desc",
    staticStyle: {
      "line-height": "14px"
    }
  }, [_vm._v(" " + _vm._s(_vm.t('注意：美国本地店铺仅支持非美国受益人的店铺授权并使用。美国本地店铺受益人归属情况请咨询TikTok客户经理。')) + " ")]) : _vm._e()], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u663E\u793A\u540D\u79F0"),
      "prop": "platform_user_name",
      "label": _vm.t('显示名称')
    }
  }, [_c('my-input', {
    staticClass: "form-item-input",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('仅用于方便您识别'),
      "maxLength": 50
    },
    model: {
      value: _vm.formData.platform_user_name,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "platform_user_name", $$v);
      },
      expression: "formData.platform_user_name"
    }
  })], 1)], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "tr"
  }, [_c('a-button', {
    attrs: {
      "data-permission": "platform_auth_tiktok_cancel",
      "id": "platform_auth_tiktok_cancel",
      "data-sign": "customer_platform_tiktok_account_auth_cancel",
      "fbu-analyse-name": $t("\u53D6\u6D88")
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v(_vm._s(_vm.t('取消')))]), _c('a-button', {
    staticClass: "ml-10",
    attrs: {
      "type": "primary",
      "data-permission": "platform_auth_tiktok_confirm",
      "id": "platform_auth_tiktok_confirm",
      "loading": _vm.loading,
      "data-sign": "customer_platform_tiktok_account_auth_action",
      "fbu-analyse-name": $t("\u786E\u5B9A")
    },
    on: {
      "click": _vm.handleOk
    }
  }, [_vm._v(_vm._s(_vm.t('确定')))])], 1)])], 1)], 1)]), _c('v-footer')], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };